import { Component, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";

@Component({
  selector: "app-toast",
  standalone: false,
  template: `
    <div class="toast-container" [ngClass]="data.panelCss">
      <mat-icon class="toast-icon">{{ data.icon }}</mat-icon>
      @if (data.renderHtml) {
        <span class="toast-message" [innerHTML]="data.message"></span>
      } @else {
        <span class="toast-message">{{ data.message }}</span>
      }
    </div>
  `,
  styleUrls: ["./toast.component.scss"],
})
export class ToastComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
